// cart count update js
document.addEventListener('DOMContentLoaded', function () {
  // Function to update cart item count
  function updateCartItemCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemCountElement = document.querySelector('.cart-count b');
        if (itemCountElement) {
          const label = cart.item_count === 1 ? 'item' : 'items';
          itemCountElement.textContent = `${cart.item_count} ${label}`;
        }

        const cartLinkBubble = document.querySelector(".cart-link__bubble");

        // Inject CSS based on cart state
        if (cart.item_count === 0) {
          addEmptyCartCSS();
          if (cartLinkBubble) {
            cartLinkBubble.classList.remove("cart-link__bubble--visible");
          }
        } else {
          removeEmptyCartCSS();
          if (cartLinkBubble) {
            cartLinkBubble.classList.add("cart-link__bubble--visible");
          }
        }
      });
  }

  // Add CSS dynamically
  function addEmptyCartCSS() {
    let styleTag = document.getElementById('empty-cart-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'empty-cart-style';
      styleTag.textContent = `
        .custom-cart { display: block; }
        #convx-style-by-us .convx-style-by-us { display: none; }
      `;
      document.head.appendChild(styleTag);
    }
  }

  // Remove CSS if not needed
  function removeEmptyCartCSS() {
    const styleTag = document.getElementById('empty-cart-style');
    if (styleTag) {
      styleTag.remove();
    }

    // Add style to show the convx-style-by-us elements when cart is not empty
    let nonEmptyStyleTag = document.getElementById('non-empty-cart-style');
    if (!nonEmptyStyleTag) {
      nonEmptyStyleTag = document.createElement('style');
      nonEmptyStyleTag.id = 'non-empty-cart-style';
      nonEmptyStyleTag.textContent = `
        #convx-style-by-us .convx-style-by-us { display: block; }
      `;
      document.head.appendChild(nonEmptyStyleTag);
    }
  }

  // Monitor changes in the cart
  function monitorCartUpdates() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      return originalFetch(...args).then((response) => {
        // Check if the request is a cart update
        if (args[0].includes('/cart/add') || args[0].includes('/cart/change') || args[0].includes('/cart/update')) {
          updateCartItemCount();
        }
        if (args[0].includes('/cart/add') && window.theme.cartPageForm) {
          window.theme.cartPageForm.buildCart();
        }
        return response;
      });
    };
  }

  // Initialize monitoring and update count on load
  monitorCartUpdates();
  updateCartItemCount();
});



// Reload Page When Cart Becomes Empty
document.addEventListener("DOMContentLoaded", function () {
  // Function to check if the cart is empty and reload
  function checkCartAndReloadIfEmpty() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        if (cart.items.length === 0) {
          location.reload();
        }
      });
  }

  // Listen for clicks on quantity minus and plus buttons
  document.body.addEventListener("click", function (e) {
    const isMinusOrPlus = e.target.closest(".js-qty__adjust");
    if (isMinusOrPlus) {
      // Wait a bit for cart to be updated
      setTimeout(() => {
        checkCartAndReloadIfEmpty();
      }, 600); // Adjust if your Ajax update is slower
    }
  });

  // Also check if quantity field is manually changed and blurred
  document.querySelectorAll(".js-qty__num").forEach((input) => {
    input.addEventListener("change", () => {
      setTimeout(() => {
        checkCartAndReloadIfEmpty();
      }, 600);
    });
  });
});


// Cart item delete button
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const deleteBtn = e.target.closest('.cart__item-delete');
    if (!deleteBtn) return;

    e.preventDefault();

    const cartItem = deleteBtn.closest('.cart__item');
    if (!cartItem || cartItem.classList.contains('is-deleting')) return;

    const itemKey = cartItem.dataset.key;
    if (!itemKey) return;

    cartItem.classList.add('is-deleting');
    deleteBtn.innerHTML = '<svg class="cart-delete-spinner" viewBox="0 0 18 18" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="9" r="7" stroke-dasharray="32" stroke-dashoffset="10" stroke-linecap="round"/></svg>';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (window.theme && window.theme.cartPageForm) {
          window.theme.cartPageForm.buildCart();
        }
        if (cart.items.length === 0) {
          location.reload();
        }
      })
      .catch(function () {
        cartItem.classList.remove('is-deleting');
      });
  });
});

// variant selector cart page and drawer
// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll(".variant-selector").forEach(function(selectEl) {
//     selectEl.addEventListener("change", function(e) {
//       e.preventDefault();

//       const newVariantId = parseInt(e.target.value, 10);
//       let lineKey = e.target.getAttribute("data-line-key");
//       const quantity = parseInt(e.target.getAttribute("data-original-quantity"), 10);

//       if (!newVariantId || !lineKey || !quantity) {
//         alert("Error: Missing variant or line item data.");
//         return;
//       }

//       // Remove old variant line
//       fetch("/cart/change.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json", "Accept": "application/json" },
//         body: JSON.stringify({ id: lineKey, quantity: 0 })
//       })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to remove old variant");
//         return res.json();
//       })
//       .then(() => {
//         // Add new variant with same quantity
//         return fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json", "Accept": "application/json" },
//           body: JSON.stringify({ id: newVariantId, quantity: quantity })
//         });
//       })
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to add new variant");
//         return res.json();
//       })
//       .then(addedItem => {
//         // Fetch updated cart
//         return fetch("/cart.js", {
//           method: "GET",
//           headers: { "Content-Type": "application/json", "Accept": "application/json" }
//         }).then(res => res.json())
//           .then(cart => ({ cart, addedItem }));
//       })
//       .then(({ cart, addedItem }) => {
//         // Find the line item key for the newly added variant (based on variant_id and quantity)
//         const newLineItem = cart.items.find(item => item.variant_id === addedItem.variant_id && item.quantity === quantity);

//         if (!newLineItem) {
//           throw new Error("Could not find updated line item");
//         }

//         // Update the dropdown's data-line-key attribute to new line item key
//         e.target.setAttribute("data-line-key", newLineItem.key);
//         e.target.setAttribute("data-original-quantity", newLineItem.quantity);

//         // Optional: update cart totals or UI here


//       })
//       .catch(error => {
//         console.error(error);

//       });
//     });
//   });
// });

// cart drawer open b0dy class js
// Global variable to store observer and prevent multiple instances
let cartObserver = null;
let isObserverActive = false;

// Function to toggle body class based on cart state
function setupCartObserver() {
  const cartElement = document.querySelector('.ast-cart');
  const body = document.body;

  if (!cartElement) {
    console.log('Cart element not found, retrying...');
    setTimeout(setupCartObserver, 500);
    return;
  }

  // If observer is already active, don't create another one
  if (isObserverActive) {
    console.log('Observer already active');
    return;
  }

  console.log('Setting up cart observer');

  // Disconnect existing observer if any
  if (cartObserver) {
    cartObserver.disconnect();
  }

  // Create a new MutationObserver
  cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;

        if (target.classList.contains('ast-open')) {
          body.classList.add('cart-is-open');
          console.log('Cart opened - added cart-is-open class to body');
        } else {
          body.classList.remove('cart-is-open');
          console.log('Cart closed - removed cart-is-open class from body');
        }
      }
    });
  });

  // Start observing
  cartObserver.observe(cartElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  isObserverActive = true;
  console.log('Cart observer is now active');

  // Check initial state
  if (cartElement.classList.contains('ast-open')) {
    body.classList.add('cart-is-open');
    console.log('Initial state: cart is open');
  }
}

// Alternative method: Use event delegation to catch cart toggle events
function setupEventDelegation() {
  console.log('Setting up event delegation fallback');

  // Listen for clicks that might trigger cart
  document.addEventListener('click', function (e) {
    // Common cart trigger selectors in Astra
    const cartTriggers = [
      '.ast-cart-menu-wrap',
      '.ast-cart-trigger',
      '.astra-cart-drawer-trigger',
      '[data-toggle-target*="ast-cart"]',
      '.ast-addon-cart-wrap'
    ];

    const isCartTrigger = cartTriggers.some(selector =>
      e.target.closest(selector)
    );

    if (isCartTrigger) {
      console.log('Cart trigger clicked');

      // Small delay to allow cart state to change
      setTimeout(function () {
        const cart = document.querySelector('.ast-cart');
        const body = document.body;

        if (cart) {
          if (cart.classList.contains('ast-open')) {
            body.classList.add('cart-is-open');
            console.log('Event delegation: Cart opened');
          } else {
            body.classList.remove('cart-is-open');
            console.log('Event delegation: Cart closed');
          }
        }
      }, 150);
    }
  });

  // Also listen for escape key to close cart
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      setTimeout(function () {
        const cart = document.querySelector('.ast-cart');
        if (cart && !cart.classList.contains('ast-open')) {
          document.body.classList.remove('cart-is-open');
          console.log('Cart closed via Escape key');
        }
      }, 150);
    }
  });
}

// Initialize everything
function initCartBodyClass() {
  console.log('Initializing cart body class functionality');

  // Set up both methods for reliability
  setupCartObserver();
  setupEventDelegation();

  // Also set up a periodic check as fallback (every 2 seconds)
  setInterval(function () {
    const cart = document.querySelector('.ast-cart');
    const body = document.body;

    if (cart) {
      const shouldHaveClass = cart.classList.contains('ast-open');
      const currentlyHasClass = body.classList.contains('cart-is-open');

      if (shouldHaveClass && !currentlyHasClass) {
        body.classList.add('cart-is-open');
        console.log('Periodic check: Added cart-is-open class');
      } else if (!shouldHaveClass && currentlyHasClass) {
        body.classList.remove('cart-is-open');
        console.log('Periodic check: Removed cart-is-open class');
      }
    }
  }, 2000);
}

// Multiple initialization attempts
function startInitialization() {
  // Try immediately
  if (document.readyState === 'complete') {
    initCartBodyClass();
  } else if (document.readyState === 'interactive') {
    setTimeout(initCartBodyClass, 100);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initCartBodyClass, 100);
    });
  }

  // Also try after window load
  window.addEventListener('load', function () {
    setTimeout(function () {
      if (!isObserverActive) {
        console.log('Retry initialization after window load');
        initCartBodyClass();
      }
    }, 500);
  });

  // jQuery fallback if available
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(function () {
      setTimeout(function () {
        if (!isObserverActive) {
          console.log('Retry initialization via jQuery');
          initCartBodyClass();
        }
      }, 200);
    });
  }
}

// Start the initialization process
startInitialization();

class ProductUpdater {
  constructor() {
    document.addEventListener("variant:change", this.onVariantChange.bind(this));
  }


  async onVariantChange(event) {
    const variantId = event.detail.variant.id;
    const response = await fetch(window.location.pathname + '?variant=' + variantId);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    this.updateStockIndicator(doc);
    this.updateStockPrice(doc);
    this.updateStickySection(doc);
  }

  updateStickySection(doc) {
    // Update variant title in sticky info
    const oldTitle = document.querySelector('.titus-sticky-navbar span');
    const newTitle = doc.querySelector('.titus-sticky-navbar span');
    if (oldTitle && newTitle) oldTitle.textContent = newTitle.textContent;

    // Update hidden input in sticky form
    const oldInput = document.querySelector('.titus-sticky-navbar input[name="id"]');
    const newInput = doc.querySelector('.titus-sticky-navbar input[name="id"]');
    if (oldInput && newInput) oldInput.value = newInput.value;

    // Update button data-product-id
    const oldButton = document.querySelector('.titus-sticky-navbar .add-to-cart-button');
    const newButton = doc.querySelector('.titus-sticky-navbar .add-to-cart-button');
    if (oldButton && newButton) {
      oldButton.setAttribute('data-product-id', newButton.getAttribute('data-product-id'));
    }
  }

  updateStockIndicator(doc) {
    const oldStockIndicator = document.querySelector(".stock-indicator");

    if (!oldStockIndicator) {
      return;
    }

    const newStockIndicator = doc.querySelector(".stock-indicator");
    oldStockIndicator.parentNode.replaceChild(newStockIndicator, oldStockIndicator);
  }

  updateStockPrice(doc) {
    const oldStockPrice = document.querySelector(".add-to-cart");

    if (!oldStockPrice) {
      return;
    }

    const newStockPrice = doc.querySelector(".add-to-cart");
    oldStockPrice.parentNode.replaceChild(newStockPrice, oldStockPrice);
  }
}

if (!window.productUpdater) {
  window.productUpdater = new ProductUpdater();
}

// ADA: add accessible name + fix contrast inside the third-party app embed
// This app embed renders its dialog inside a shadow root (see convx-2.js,
// which reaches it via `container.shadowRoot`), so regular light-DOM
// querySelector/MutationObserver/stylesheets never reach it - a plain
// #app-embed-container-304645 rule in custom.css is a no-op. Everything
// here must go through container.shadowRoot explicitly.
(function () {
  const CONTRAST_STYLE_ID = 'ada-app-embed-304645-contrast-fix';
  const warnedNestedRoots = new WeakSet();

  // Partial [class*=...] matches instead of exact hashed classnames: Globo
  // (vendor: Powerful Form Builder, see config/settings_data.json block
  // 6279071938380501511) rebuilds its CSS modules on redeploy, which
  // rotates the numeric hash suffix (_2aowh_, _1mxsl_, etc). Matching on
  // the stable name prefix survives those rebuilds; exact-hash selectors
  // silently stop matching the next time the vendor ships an update.
  const CONTRAST_CSS = `
    /* #000000 on #666666 banner = 3.66:1 (fail). #ffffff = 5.74:1 (pass) */

    /* #1878b9 link on #666666 banner = 1.21:1 (fail). #D6EBFB = 4.6:1 (pass) */
    a[title="privacy policy"],
    a[href$="privacy-policy"],
    a[href$="terms-of-service"],
    a[title="privacy policy"]:visited,
    a[href$="privacy-policy"]:visited,
    a[href$="terms-of-service"]:visited {
      color: #035a99 !important;
      text-decoration: underline; /* non-color cue, WCAG 1.4.1 */
    }

    a[title="privacy policy"]:hover,
    a[href$="privacy-policy"]:hover,
    a[href$="terms-of-service"]:hover,
    a[title="privacy policy"]:focus,
    a[href$="privacy-policy"]:focus,
    a[href$="terms-of-service"]:focus {
      color: #ffffff !important;
      text-decoration: underline;
    }

    /* #909090 label on #ffffff form = 3.19:1 (fail). #767676 = 4.54:1 (pass) */
    #label-first_nam,
    #label-first_name,
    #label-email,
    #label-phone_number,
    [class*="_formInputFieldLabel_"],
    [id^="label-"] {
      color: #767676 !important;
    }
  `;

  function labelDialog(root) {
    const dialog = root.querySelector('[role="dialog"]');
    if (!dialog) return false;
    if (!dialog.hasAttribute('aria-label') && !dialog.hasAttribute('aria-labelledby')) {
      dialog.setAttribute('aria-label', 'Newsletter signup');
    }
    return true;
  }

  function injectContrastFix(root) {
    if (root.getElementById && root.getElementById(CONTRAST_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = CONTRAST_STYLE_ID;
    style.textContent = CONTRAST_CSS;
    root.append(style);
  }

  // Some vendor widgets nest a second custom element (with its own shadow
  // root) inside the outer one for the form fields specifically. A style
  // appended to the outer root can't reach an inner shadow root either -
  // same encapsulation boundary, one level deeper - so each nested root
  // found needs its own injected copy.
  function findNestedShadowRoots(root) {
    const nested = [];
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) nested.push(el.shadowRoot);
    });
    return nested;
  }

  function applyFixes(root) {
    labelDialog(root);
    injectContrastFix(root);

    findNestedShadowRoots(root).forEach((nestedRoot) => {
      if (!warnedNestedRoots.has(nestedRoot)) {
        warnedNestedRoots.add(nestedRoot);
        console.warn(
          'ADA fix: nested shadow root detected inside the app-embed-container widget - injecting contrast fix into it too.',
          nestedRoot.host
        );
      }
      injectContrastFix(nestedRoot);
    });
  }

  function watchShadowRoot(container) {
    if (!container.shadowRoot) return false;
    const shadowRoot = container.shadowRoot;

    applyFixes(shadowRoot);

    const shadowObserver = new MutationObserver(() => {
      applyFixes(shadowRoot);
    });
    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
    return true;
  }

  function findContainer() {
    const container = document.querySelector('[id^="app-embed-container"]');
    if (!container) return false;
    return watchShadowRoot(container);
  }

  if (findContainer()) return;

  const documentObserver = new MutationObserver(() => {
    if (findContainer()) documentObserver.disconnect();
  });

  documentObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// ADA: fix third-party add-on app injecting <h3 class="ast-addon-title"> which skips h2
(function () {
  function fixAddonHeading() {
    var h3 = document.querySelector('h3.ast-addon-title');
    if (!h3) return false;
    var h2 = document.createElement('h2');
    h2.className = h3.className;
    h2.innerHTML = h3.innerHTML;
    Array.from(h3.attributes).forEach(function (attr) {
      if (attr.name !== 'class') h2.setAttribute(attr.name, attr.value);
    });
    h3.parentNode.replaceChild(h2, h3);
    return true;
  }

  if (fixAddonHeading()) return;

  var addonObserver = new MutationObserver(function () {
    if (fixAddonHeading()) addonObserver.disconnect();
  });
  addonObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// ADA: add alt text to page-body .mxp-feat-icon images (stored in Shopify page content, not theme files)
(function () {
  var ALT_MAP = {
    'icon-magnetic': 'Magnetic movable headrest feature icon',
    'icon-seat': 'Ergonomic seat cushion feature icon',
    'icon-form': 'Ergonomic form design feature icon',
  };

  function fixMxpIcons() {
    var imgs = document.querySelectorAll('.mxp-feat-icon img:not([alt])');
    if (!imgs.length) return false;
    imgs.forEach(function (img) {
      var src = img.getAttribute('src') || '';
      var key = Object.keys(ALT_MAP).find(function (k) { return src.indexOf(k) !== -1; });
      img.setAttribute('alt', key ? ALT_MAP[key] : '');
    });
    return true;
  }

  if (fixMxpIcons()) return;

  var mxpObserver = new MutationObserver(function () {
    if (fixMxpIcons()) mxpObserver.disconnect();
  });
  mxpObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// ADA: remove nested interactive elements from tab order inside ast-addon-item checkboxes.
// The add-on app renders role="checkbox" cards that contain <a> and <button> descendants,
// violating WCAG 4.1.2 (nested interactive controls). Setting tabindex="-1" on inner
// focusables keeps the parent checkbox as the single keyboard target for each card.
// Re-queries the whole document on every mutation (not just newly added subtrees) because
// the app sometimes injects focusable descendants into a checkbox card that already exists,
// which a "does this added node match/contain the card selector" check would miss.
// Observer does NOT disconnect — carousel slides are replaced dynamically.
(function () {
  var NESTED_SELECTOR = [
    '[role="checkbox"].ast-addon-item a[href]',
    '[role="checkbox"].ast-addon-item button',
    '[role="checkbox"].ast-addon-item input',
    '[role="checkbox"].ast-addon-item select',
    '[role="checkbox"].ast-addon-item textarea'
  ].join(', ');

  function fixNestedInteractive() {
    document.querySelectorAll(NESTED_SELECTOR).forEach(function (el) {
      if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
      if (el.tagName === 'SELECT' && !el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
        el.setAttribute('aria-label', 'Quantity');
      }
    });
  }

  fixNestedInteractive();

  var astObserver = new MutationObserver(fixNestedInteractive);
  astObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// ADA: add alt text to the page-body legrest caution image (stored in Shopify page
// content, not theme files) that ships with no alt attribute — fails WCAG 1.1.1.
(function () {
  function fixMxpCautionIcon() {
    var img = document.querySelector('.mxp-s4-text img[src*="caution-02"]:not([alt])');
    if (!img) return false;
    img.setAttribute('alt', 'Caution for Maxx Pro Legrest');
    return true;
  }

  if (fixMxpCautionIcon()) return;

  var cautionObserver = new MutationObserver(function () {
    if (fixMxpCautionIcon()) cautionObserver.disconnect();
  });
  cautionObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  function fixSlickTabindex() {
    document.querySelectorAll('.slick-slide[tabindex="0"]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
  }
  fixSlickTabindex();
  var slickTabObserver = new MutationObserver(function () {
    fixSlickTabindex();
  });
  slickTabObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['tabindex']
  });

  // MutationObserver above is async and can lose the race against Slick's own
  // autoplay/centerMode transitions, which re-apply tabindex="0" on every slide
  // change. Hook Slick's own (synchronous) lifecycle events as the primary fix;
  // the observer stays as a fallback for slick instances not covered here.
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('init reInit afterChange breakpoint setPosition', '.slick-slider', fixSlickTabindex);
  }
})();

(function () {
  function fixJdgmRatingTabindex() {
    document.querySelectorAll('.jdgm-rev__rating[tabindex="0"]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
  }
  fixJdgmRatingTabindex();
  var jdgmRatingObserver = new MutationObserver(function () {
    fixJdgmRatingTabindex();
  });
  jdgmRatingObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
(function () {
  function fixJdgmSummaryStars() {
    document.querySelectorAll('.jdgm-rev-widg__summary-stars').forEach(function (el) {
      if (el.getAttribute('tabindex') === '0') {
        el.setAttribute('tabindex', '-1');
      }
      el.querySelectorAll('[tabindex="0"]').forEach(function (child) {
        child.setAttribute('tabindex', '-1');
      });
    });
  }
  fixJdgmSummaryStars();
  var summaryStarsObserver = new MutationObserver(function () {
    fixJdgmSummaryStars();
  });
  summaryStarsObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
(function () {
  var SELECTOR = '.description-block-two.newproductboxtwo > div > h3';
  function fixNewproductboxtwoHeading() {
    var h3 = document.querySelector(SELECTOR);
    if (!h3) return false;
    var h2 = document.createElement('h2');
    h2.className = h3.className;
    h2.innerHTML = h3.innerHTML;
    Array.from(h3.attributes).forEach(function (attr) {
      if (attr.name !== 'class') h2.setAttribute(attr.name, attr.value);
    });
    h3.parentNode.replaceChild(h2, h3);
    return true;
  }
  if (fixNewproductboxtwoHeading()) return;
  var newproductObserver = new MutationObserver(function () {
    if (fixNewproductboxtwoHeading()) newproductObserver.disconnect();
  });
  newproductObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
(function () {
  var ALT_MAP = {
    'kittypaw-ProPic-1': 'TTRacing Arm Warmer Plush KittyPaw - product photo 1',
    'kittypaw-ProPic-2': 'TTRacing Arm Warmer Plush KittyPaw - product photo 2',
    'kittypaw-ProPic-3': 'TTRacing Arm Warmer Plush KittyPaw - product photo 3',
    'kittypaw-ProPic-4': 'TTRacing Arm Warmer Plush KittyPaw - product photo 4',
  };
  function fixKittypawImages() {
    var imgs = document.querySelectorAll('.description-block-one.newproductboxone img:not([alt])');
    if (!imgs.length) return false;
    imgs.forEach(function (img) {
      var src = img.getAttribute('src') || '';
      var key = Object.keys(ALT_MAP).find(function (k) { return src.indexOf(k) !== -1; });
      img.setAttribute('alt', key ? ALT_MAP[key] : '');
    });
    return true;
  }
  if (fixKittypawImages()) return;
  var kittypawImgObserver = new MutationObserver(function () {
    if (fixKittypawImages()) kittypawImgObserver.disconnect();
  });
  kittypawImgObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// ADA: WCAG 2.5.3 — country trigger accessible name must contain visible text "US"
// Runs after DOMContentLoaded to override any runtime script that sets aria-label="Select country"
(function () {
  function fixCountryTriggers() {
    document.querySelectorAll('.country-trigger, .mobile-country-trigger').forEach(function (btn) {
      var span = btn.querySelector('span');
      var label = span ? span.textContent.trim() : '';
      if (label) btn.setAttribute('aria-label', label + ' - Select country');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCountryTriggers);
  } else {
    fixCountryTriggers();
  }
})();